import { render, staticRenderFns } from "./UserEditTabInformation.vue?vue&type=template&id=2588cd94"
import script from "./UserEditTabInformation.vue?vue&type=script&lang=js"
export * from "./UserEditTabInformation.vue?vue&type=script&lang=js"
import style0 from "./UserEditTabInformation.vue?vue&type=style&index=0&id=2588cd94&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports